import { Component,ElementRef, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.css']
})
export class PublicationsComponent implements OnInit {
  arrayPublicationCategroy:any
  arrayPublications:any
  id: any
  selectedItem: any
  ShowTitle:boolean=false;
  load: boolean = false
  array:any=[]
  array2:any=[]
  array3:any=[]
  Title:any;
  vv:any

  constructor(private elementRef: ElementRef,private homeService_: HomeService,private _Activatedroute: ActivatedRoute) {
    this._Activatedroute.paramMap.subscribe(params => {
      this.getAll()
      window.scroll(0, 0);
    });
   }

  ngOnInit(): void {
    this.load = false;
    // this.ShowTitle=true;
    // this.id = this._Activatedroute.snapshot.paramMap.get("id")

    var s15 = document.createElement("script");
    s15.type = "text/javascript";
    s15.src = "../../../assets/js/plugins.js";
    this.elementRef.nativeElement.appendChild(s15);

    var s15 = document.createElement("script");
    s15.type = "text/javascript";
    s15.src = "../../../assets/js/main.js";
    this.elementRef.nativeElement.appendChild(s15);

    // if (this.id == null || this.id == '') {
    //   this.selectedItem = null

    //   this.homeService_.getPost('getPost','', 'en', '', 'PublicationCategroy', 'NTROOT0', '', '-1').subscribe(data => {
    //     this.arrayPublicationCategroy = data
    //     this.homeService_.getPost('getPostDetails', '', 'en', '', 'Publications', '', '', '-1').subscribe(data => {
    //       this.arrayPublications = data
    //         this.load = true
    //     })
    //   })
    // }
    // else
    // this.homeService_.getPost('getPost','', 'en', '', 'PublicationCategroy', 'NTROOT0', '', '-1').subscribe(data => {
    //   this.arrayPublicationCategroy = data
    // this.homeService_.getPost('getPostDetails', '', 'en', '', 'Publications', this.id, '', '-1').subscribe(data => {
    //       this.selectedItem = this.id
    //       this.arrayPublications = data
    //       console.log("hghh",data)
    //       setTimeout(() => {
    //         this.load = true
    //       }, 2000);
    //        })
    //   })
  }

  getTitle(){
           this.ShowTitle=true;
  }
  getPublications() {
    this.load = false
    this.ShowTitle=false;
    // this.selectedItem = sectionId
    
    this.homeService_.getPost('getPost', '', 'en', '', 'Publications', "NTROOT0", '', '-1').subscribe(data => {
      this.arrayPublications = data
        this.Title=this._Activatedroute.snapshot.paramMap.get("title");
        
      setTimeout(() => {
        this.load = true
      }, 2000);
    })
  }

  getAll()
  {

    this.array = [];
    this.array2=[];
    this.id = this._Activatedroute.snapshot.paramMap.get("id");
    this.Title=this._Activatedroute.snapshot.paramMap.get("title");

    if (this.id == null || this.id == '') {
      this.selectedItem = null;
      this.ShowTitle=true;
      this.homeService_.getPost('getPostDetails','', 'en', '', 'PublicationCategroy', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayPublicationCategroy = data

        console.log('aa',data)
        let arr = data as []
        this.homeService_.getPost('getPostDetails', '', 'en', '', 'Publications', '', '', '-1').subscribe(data => {
          this.arrayPublications = data

          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postDetails:el2['postDetails'],postImage:el2['postImage'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourPublication:this.array
               }
           )

               this.array = []
          })
          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
    else
    {
      this.ShowTitle=false;
    this.homeService_.getPost('getPostDetails','', 'en', '', 'PublicationCategroy', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayPublicationCategroy = data

      let arr = data as []

    this.homeService_.getPost('getPostDetails', '', 'en', '', 'Publications', this.id, '', '-1').subscribe(data => {
          this.selectedItem = this.id
          this.arrayPublications = data


          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postDetails:el2['postDetails'],postImage:el2['postImage'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourPublication:this.array
               }
           )

               this.array = []
          })


          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
      // console.log(this.array2)

    }

}
